import React from 'react';
import PropTypes from 'prop-types';
import MoveTo from 'moveto';
import { css } from '@bd/bdui-styles/emotion';
import { menuToggler } from '@bd/bdcore-utilities';
import FilterBar from './FilterBar';
import AppliedFilters from './AppliedFilters';
import { colors } from '../styles';

const styles = css`
  position: relative;
  .FilterSortButton_wrapper {
    padding: 10px 15px;
    background-color: ${colors.color3};
    text-align: left;
  }
  .Filter_button {
    display: inline-block;
    line-height: 38px;
    height: 40px;
    margin: 0 10px 0 0;
    cursor: pointer;
    color: white;
    background-color: ${colors.color2};
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    border: 0;
    padding: 0 10px;
    border: 1px solid ${colors.color2};
    border-radius: 5px;
    img {
      height: 20px;
      width: auto;
      margin: 0 10px 0 0;
    }
    &:focus {
      outline: 0;
      box-shadow: 0;
      background-color: ${colors.color2};
      color: #FFFFFF;
    }
  }
  .Sort_button {
    display: inline-block;
    line-height: 38px;
    height: 40px;
    margin: 0 10px 0 0;
    cursor: pointer;
    color: white;
    background-color: ${colors.color2};
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    border: 0;
    padding: 0 25px 0 10px;
    border: 1px solid ${colors.color2};
    border-radius: 5px;
    background-image: url('/images/icon-triangle-white.svg');
    background-position: calc(100% - 12px) center;
    background-repeat: no-repeat;
    &:focus {
      outline: 0;
      box-shadow: 0;
      background-color: ${colors.color2};
      color: #FFFFFF;
    }
  }
  .Sort_dropdown {
    position: absolute;
    list-style: none;
    padding: 0 10px;
    background: #FFFFFF;
    box-shadow: 0 10px 15px 0 rgba(0,0,0,0.50);
    background-color: ${colors.color3Lighter};
    z-index: 10;
  }
  .Sort_dropdownItem {
    font-weight: 300;
    font-size: 14px;
    color: #3F3F3F;
    border-bottom: 1px solid #CFCFCF;
    width: 100%;
    padding: 10px 0;
    cursor: pointer;
    &:last-child {
      border: 0;
    }
  }
  .Sort_dropdownItemButton {
    display: block;
    width: 100%;
  }

  .ShowMap_button {
    line-height: 40px;
    height: 40px;
    display: inline-block;
    margin: 0 10px 0 0;
    cursor: pointer;
    color: #FFFFFF;
    background-color: ${colors.color2};
    font-size: 13px;
    font-weight: 700;
    text-align: center;
    border: 0;
    padding: 0 10px;
    border: 1px solid ${colors.color2};
    border-radius: 5px;
    display: none;
    img {
      height: 16px;
      width: auto;
      margin: -2px 5px 0 0;
      display: inline-block;
    }
    cursor: pointer;
    &:focus {
      outline: 0;
      box-shadow: 0;
    }
  }
  .FilterScreen_wrapper {
    display: none;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #FFFFFF;
    padding: 60px 30px;
    overflow-y: scroll;
    &.active {
      display: block;
    }
    @media (min-width: 992px) {
      position: absolute;
      width: 350px;
      left: 15px;
      top: 60px;
      right: auto;
      bottom: auto;
      padding: 20px;
      box-shadow: 0 2px 2px 0 rgba(0,0,0,0.20);
    }
  }
  .FilterScreen_closeBtn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 18px;
    top: 20px;
    display: block;
    background-image: url('/images/icon-close.svg');
    background-size: 20px 20px;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: transparent;
    border: 0;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .FilterScreen_doneBtn {
    margin: 15px 0 0 15px;
    padding: 0 20px;
    line-height: 38px;
    height: 40px;
    font-size: 14px;
  }
`;

function scrollToTop(ref) {
  setTimeout(() => {
    const moveTo = new MoveTo({
      tolerance: 100,
    });
    moveTo.move(ref);
  }, 100);
}

function Filters(props) {
  const {
    activeSort, activateMenu, isActiveMenu,
    sortOptions, onSortSelect, scrollRef,
    showMap, onToggleMap, hideOnDesktop,
  } = props;
  return (
    <div className={styles}>
      <div className="FilterSortButton_wrapper">
        <span className="Filter_button" role="button" tabIndex="0" onClick={activateMenu('filters')} onKeyDown={activateMenu('filters')}>
          Filters
        </span>
        <div className="d-inline-block">
          <span role="button" tabIndex="0" className="Sort_button" onClick={activateMenu('sort')} onKeyDown={activateMenu('sort')}>
            <span className="Sort_buttonLabel">Sort By: </span> {activeSort.title}
          </span>
          {
            isActiveMenu('sort') &&
            <ul className="Sort_dropdown">
              { sortOptions.map(option => (
                <li className="Sort_dropdownItem" key={option.title}>
                  <span
                    className="Sort_dropdownItemButton"
                    role="button"
                    tabIndex="0"
                    onClick={() => {
                      scrollToTop(scrollRef);
                      onSortSelect(option);
                    }}
                  >
                    {option.title}
                  </span>
                </li>
              ))}
            </ul>
          }
        </div>
        {
          onToggleMap &&
          <span
            className={`ShowMap_button ${hideOnDesktop && 'd-lg-none'}`}
            role="button"
            tabIndex="0"
            onClick={() => onToggleMap(!showMap)}
            onKeyDown={event => ((!event.which || [13, 32].includes(event.which)) ? onToggleMap(!showMap) : '')}
          >
            {
              !showMap &&
              <img src="/images/icon-map-pin-white.svg" alt="" />
            }
            {
              showMap &&
              <img src="/images/icon-grid-white.svg" alt="" />
            }
            <span className="ShowMap_buttonLabel">
              {`${showMap ?
                'List'
                :
                'Map'}`}
            </span>
          </span>
        }
      </div>
      <div className={`FilterScreen_wrapper ${isActiveMenu('filters') && 'active'}`}>
        <button className="FilterScreen_closeBtn" onClick={activateMenu(null)} />
        <FilterBar
          {...props}
        />
        <AppliedFilters
          {...props}
          clearButton={<span className="ResetFilter_button">Reset Filters <img src="/images/icon-refresh-blue.svg" alt="" /></span>}
        />
        <button className="btn FilterScreen_doneBtn" onClick={activateMenu(null)}>Done</button>
      </div>
    </div>
  );
}

Filters.propTypes = {
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  onSortSelect: PropTypes.func.isRequired,
  onToggleMap: PropTypes.func,
  sortOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeSort: PropTypes.object.isRequired,
  scrollRef: PropTypes.object,
  showMap: PropTypes.bool,
  hideOnDesktop: PropTypes.bool,
};

Filters.defaultProps = {
  scrollRef: document.getElementsByTagName('body')[0],
  onToggleMap: undefined,
  showMap: undefined,
  hideOnDesktop: undefined,
};

export default menuToggler(Filters);



// WEBPACK FOOTER //
// ./src/components/Filters.js